var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var Disposable;
(function (Disposable) {
    Disposable.NONE = {
        dispose: function () {
            // noop
        },
    };
})(Disposable || (Disposable = {}));
var CompositeDisposable = /** @class */ (function () {
    function CompositeDisposable() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.disposables = args;
    }
    CompositeDisposable.from = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new (CompositeDisposable.bind.apply(CompositeDisposable, __spreadArray([void 0], __read(args))))();
    };
    CompositeDisposable.prototype.addDisposables = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        args === null || args === void 0 ? void 0 : args.forEach(function (arg) { return _this.disposables.push(arg); });
    };
    CompositeDisposable.prototype.dispose = function () {
        this.disposables.forEach(function (arg) { return arg.dispose(); });
    };
    return CompositeDisposable;
}());
export { CompositeDisposable };
var MutableDisposable = /** @class */ (function () {
    function MutableDisposable() {
        this._disposable = Disposable.NONE;
    }
    Object.defineProperty(MutableDisposable.prototype, "value", {
        set: function (disposable) {
            if (this._disposable) {
                this._disposable.dispose();
            }
            this._disposable = disposable;
        },
        enumerable: false,
        configurable: true
    });
    MutableDisposable.prototype.dispose = function () {
        if (this._disposable) {
            this._disposable.dispose();
        }
    };
    return MutableDisposable;
}());
export { MutableDisposable };
